module.exports = __webpack_public_path__ + "static/power2-3-843070b7e4c6759b65b5e523c06277a0.png";